import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "p-4 position-fixed bottom-1 start-0" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "btn btn-outline-primary",
    "data-bs-toggle": "offcanvas",
    href: "#offcanvasExample",
    role: "button",
    "aria-controls": "offcanvasExample"
  }, " Dev. Options ")
], -1)
const _hoisted_2 = {
  class: "offcanvas offcanvas-start bg-dark text-white",
  tabindex: "-1",
  id: "offcanvasExample",
  "aria-labelledby": "offcanvasExampleLabel"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "offcanvas-header" }, [
  /*#__PURE__*/_createElementVNode("h3", {
    class: "offcanvas-title",
    id: "offcanvasExampleLabel"
  }, " Development Options "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close text-reset btn-close-white",
    "data-bs-dismiss": "offcanvas",
    "aria-label": "Close"
  })
], -1)
const _hoisted_4 = { class: "offcanvas-body" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, " This menu is intended purely for development purposes and allows users to quickly move through sections of the site. ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-3" }, "Sections", -1)
const _hoisted_8 = {
  class: "btn-group-vertical w-100",
  role: "group",
  "aria-label": "Basic example"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = { class: "form-check mt-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "devOptionShowKeyQuestions"
}, [
  /*#__PURE__*/_createElementVNode("small", null, "Show only an abbreviated question list for a quicker journey")
], -1)
const _hoisted_13 = { class: "form-check mt-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "devOptionYesOutcome"
}, [
  /*#__PURE__*/_createElementVNode("small", null, "Show alternative outcome")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_16 = { class: "mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-light",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSkipToQuestionsClicked && _ctx.onSkipToQuestionsClicked(...args)))
          }, " Go to the Information section "),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-light",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSkipToCalcsClicked && _ctx.onSkipToCalcsClicked(...args)))
          }, " Go to the Calculation section "),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-light",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSkipToNextSectionClicked && _ctx.onSkipToNextSectionClicked(...args)))
          }, " Go to the next section "),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-light",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSetTerminusClicked && _ctx.onSetTerminusClicked(...args)))
          }, " Set Terminus ")
        ]),
        _hoisted_9,
        _withDirectives(_createElementVNode("h5", _hoisted_10, "Other options", 512), [
          [_vShow, false]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_11, [
          _createElementVNode("input", {
            ref: "devOptionShowKeyQuestions",
            id: "devOptionShowKeyQuestions",
            class: "form-check-input",
            type: "checkbox",
            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('key-questions-changed', $event.target.checked)))
          }, null, 544),
          _hoisted_12
        ], 512), [
          [_vShow, false]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_13, [
          _createElementVNode("input", {
            ref: "devOptionYesOutcome",
            id: "devOptionYesOutcome",
            class: "form-check-input",
            type: "checkbox",
            onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.changeOutcome && _ctx.changeOutcome(...args)))
          }, null, 544),
          _hoisted_14
        ], 512), [
          [_vShow, true]
        ]),
        _hoisted_15,
        _withDirectives(_createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            type: "button",
            id: "generateCodes",
            class: "btn btn-outline-light",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onGenerateCodesClicked && _ctx.onGenerateCodesClicked(...args)))
          }, " Manage Access Codes ")
        ], 512), [
          [_vShow, true]
        ])
      ])
    ])
  ], 64))
}